{
  "name": "alive-angular",
  "version": "3.5.4",
  "scripts": {
    "ng": "ng",
    "start": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0",
    "start:fr": "npm run deployFixes && ng serve --port=4567 --host=0.0.0.0 --configuration=fr",
    "deployFixes": "node deployFixes.mjs",
    "b": "npm run build:prod",
    "bd": "npm run build:prod && npm run deploy:prod",
    "build": "npm run deployFixes && ng build",
    "build:prod": "npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run build:prod_en && npm run build:prod_fr && npm run build:prod_es",
    "deploy:prod": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && node deployNonIndexFiles.js",
    "deploy:prod:index": "node deployIndexFiles.js",
    "bdtest": "npm run build:test && npm run deploy:test",
    "build:test": "npm run deployFixes && npm run generate:sitemaps && npm run generate:robots && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && npm run build:test_en && npm run build:test_fr && npm run build:test_es",
    "deploy:test": "node deployTestFiles.js",
    "build:prod_en": "ng build -c=production --deploy-url https://livestatic.athletic.net/ && node_modules/.bin/gulp b --locale en",
    "build:prod_fr": "ng build -c=production,fr --deploy-url https://livestatic.athletic.net/fr/ && node_modules/.bin/gulp b --locale fr",
    "build:prod_es": "ng build -c=production,es --deploy-url https://livestatic.athletic.net/es/ && node_modules/.bin/gulp b --locale es",
    "build:test_en": "ng build -c=production && node_modules/.bin/gulp b --locale en",
    "build:test_fr": "ng build -c=production,fr && node_modules/.bin/gulp b --locale fr",
    "build:test_es": "ng build -c=production,es && node_modules/.bin/gulp b --locale es",
    "generate:sitemaps": "node generateSiteMaps.js",
    "generate:robots": "node generateRobotsTxt.js",
    "extracti18n": "ng extract-i18n --out-file src/locale/messages.xlf && npx prettier src/locale/messages.xlf --write --plugin=@prettier/plugin-xml",
    "sentry:sourcemaps": "sentry-cli releases new --org spikefalcon --project athletic-live-angular $npm_package_version && sentry-cli sourcemaps inject --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser && sentry-cli sourcemaps upload --release=$npm_package_version --org spikefalcon --project athletic-live-angular ./dist/alive-angular/browser",
    "sentry:sourcemaps:remove": "rm -r dist/alive-angular/browser/*.map",
    "watch": "npm run deployFixes && ng build --watch --configuration development",
    "format": "prettier --write '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "lint:format": "prettier --check '**/?(.)*.{css,scss,js,ts,tsx,json,yaml,yml,html}'",
    "prepare": "husky",
    "---unused/deprecated commands below---": "",
    "buildProdSingleSite": "npm run deployFixes && npx createAngularStaticHashes --staticAssetsPath=src/assets --globPattern=/**/config.json && ng build -c=production && node_modules/.bin/gulp b",
    "deployProdSingleSite": "npm run sentry:sourcemaps && npm run sentry:sourcemaps:remove && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld && rsync --exclude=\"{'index.html'}\" -a dist/alive-angular/browser/ admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld",
    "deployProdSingleSiteIndex": "rsync dist/alive-angular/browser/index.html admin@web21:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html && rsync dist/alive-angular/browser/index.html admin@107.170.36.19:/srv/www/trackmeet.io/htdocs/dist_new_qld/index.html",
    "serve:ssr:alive-angular": "node dist/alive-angular/server/server.mjs",
    "mtr": "git checkout master && git pull origin master && git checkout release && git merge master"
  },
  "engines": {
    "node": "24.x",
    "npm": "^11.10"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.0.6",
    "@angular/common": "^22.0.8",
    "@angular/compiler": "^22.0.8",
    "@angular/core": "^22.0.8",
    "@angular/forms": "^22.0.8",
    "@angular/platform-browser": "^22.0.8",
    "@angular/platform-browser-dynamic": "^22.0.8",
    "@angular/platform-server": "^22.0.8",
    "@angular/router": "^22.0.8",
    "@angular/ssr": "^22.0.8",
    "@athleticnet/athletic-live-api": "^22.0.11",
    "@athleticnet/athletic-live-api-models": "^4.0.8",
    "@brightcove/player-loader": "^1.8.0",
    "@fortawesome/angular-fontawesome": "^5.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-brands-svg-icons": "^7.0.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.0.0",
    "@fortawesome/pro-light-svg-icons": "^7.0.0",
    "@fortawesome/pro-regular-svg-icons": "^7.0.0",
    "@fortawesome/pro-solid-svg-icons": "^7.0.0",
    "@fortawesome/sharp-regular-svg-icons": "^7.0.0",
    "@fortawesome/sharp-solid-svg-icons": "^7.0.0",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ng-select/ng-select": "^23.5.1",
    "@sentry/angular": "^10.68.0",
    "@sitelintcode/angular-static-assets-hash": "^0.0.28",
    "bootstrap": "^5.3.8",
    "express": "^5.2.1",
    "firebase": "^12.13.0",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.7.2",
    "minimist": "^1.2.8",
    "ngx-cookie-service": "^22.0.0",
    "ngx-countdown": "^21.0.0",
    "rxjs": "~7.8.0",
    "swiper": "^12.1.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^22.0.8",
    "@angular/cli": "~22.0.8",
    "@angular/compiler-cli": "^22.0.8",
    "@angular/localize": "^22.0.8",
    "@prettier/plugin-xml": "^3.4.1",
    "@sentry/cli": "^3.4.2",
    "@types/express": "^5.0.6",
    "@types/luxon": "^3.3.2",
    "@types/node": "^24.0.0",
    "@types/video.js": "^7.3.46",
    "browser-sync": "^3.0.0",
    "gulp": "^5.0.1",
    "gulp-inject": "^5.0.5",
    "gulp-inject-string": "^1.1.2",
    "gulp-replace": "^1.1.4",
    "husky": "^9.0.11",
    "lint-staged": "^15.2.2",
    "prettier": "^3.8.3",
    "replace-in-file": "^8.4.0",
    "source-map-explorer": "^2.5.3",
    "typescript": "~6.0.3"
  },
  "lint-staged": {
    "*.{css,scss,js,ts,tsx,json,yaml,yml,html}": "prettier --write"
  },
  "allowScripts": {
    "@parcel/watcher@2.5.6": true,
    "fsevents@2.3.3": true,
    "fsevents@1.2.13": true,
    "//es5-ext has protestware install script against russia war crimes, legitimate software though": "",
    "es5-ext": false,
    "protobufjs@7.6.1": true,
    "lmdb@3.5.1": true,
    "msgpackr-extract@3.0.4": true,
    "esbuild@0.27.3": true,
    "@sentry/cli@3.4.3": true,
    "@firebase/util@1.15.1": true
  }
}
